<template>
    <div class="content-lesson-planing margin-top-10">
        <div class="row">
            <div class="col-md-4 wrap-left">
                <div>
                    <div class="name cursor-pointer">
                        <h5>
                            <strong>{{ dataLessonPlaning.name }}</strong>
                            <img v-if="listLessonPlaning.length > 0" class="icon-down-arrow width-20"
                                src="@/assets/img/down-arrow.png" />
                        </h5>
                    </div>
                    <div v-for="(item, index) of listLessonPlaning" :key="index"
                        class="item-electronic-lecture mt-3 indented">
                        <div class="name cursor-pointer" @click="handleOnCollapse(item)">
                            <h5>
                                <strong>{{ item.name }}</strong>
                                <img v-if="item.listChapterClassSchool.length > 0" class="icon-down-arrow width-20"
                                    src="@/assets/img/down-arrow.png" />
                            </h5>
                        </div>
                        <b-collapse class="wrap-list-chapter indented" :visible="item.isCollapse">
                            <div v-for="(chapter, indexChapter) of item.listChapterClassSchool" :key="indexChapter"
                                class="item-chapter">
                                <h6 @click="handleOnCollapse(chapter)" class="wrap-name-item pb-1 pt-2 cursor-pointer">
                                    <strong>{{ chapter.name }}</strong>
                                    <img v-if="chapter.listPostClassSchool.length > 0" class="icon-down-arrow width-20"
                                        src="@/assets/img/down-arrow.png" />
                                </h6>
                                <b-collapse v-for="(poster, indexPoster) of chapter.listPostClassSchool"
                                    :key="indexPoster" class="wrap-list-post indented" :visible="chapter.isCollapse">
                                    <div class="item-post">
                                        <div class="wrap-name-item pt-1 mb-2">{{ poster.name }}</div>
                                        <div v-for="(document, indexDocument) of poster.listDocumentClassSchool"
                                            :key="indexDocument"
                                            class="wrap-list-document display-flex-column rg-half-1">
                                            <div class="item-document display-flex cursor-pointer">
                                                <b-form-checkbox v-model="document.isCheck" name="radio"
                                                    :disabled="true">

                                                </b-form-checkbox>
                                                <div @click="handleOnViewDocument($event, document)"> {{ document.name
                                                    }}
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </b-collapse>
                            </div>
                        </b-collapse>

                    </div>
                </div>
                <div class="wrap-file mt-3">
                    <div class="title cursor-pointer" @click="handleOnCollapseFile">
                        <h6><strong>Tài liệu đính kèm
                                <img class="icon-down-arrow width-20" src="@/assets/img/down-arrow.png"
                                    v-if="listDataFile.length > 0" />
                            </strong>
                        </h6>

                    </div>
                    <b-collapse class="wrap-list-file indented display-flex-column rg-half-1" :visible="isCollapseFile">
                        <div v-for="(item, index) of listDataFile" :key="index" class="item-file">
                            <div @click="handleOnViewFile(item)">
                                <img class="icon-photo" src="@/assets/img/photo.png" />
                                {{ item.name }}
                            </div>
                        </div>
                    </b-collapse>
                </div>

                <div class="wrap-list-task-lesson mt-3">
                    <div class="tittle cursor-pointer" @click="handleCollapseLearningTask">
                        <h6><strong>Nhiệm vụ học tập</strong><img v-if="listLearningTaskLesson.length > 0"
                                class="icon-down-arrow width-20" src="@/assets/img/down-arrow.png" /></h6>

                    </div>
                    <b-collapse class="wrap-list-chapter indented" :visible="isCollapseLearningTask">
                        <div class="wrap-list-task-lesson-item indented mb-1 cursor-pointer"
                            v-for="(item, index) of listLearningTaskLesson" :key="index">
                            <div class="display-flex-center">
                                <b-form-checkbox disabled
                                    :checked="item.countUserCurrentAnswer >= item.countQuestion && item.countUserCurrentAnswer > 0"
                                    :id="'checkbox_' + index"></b-form-checkbox>
                                <label class="mb-0" :for="'checkbox_' + index" @click="handleOnTask(item)">{{
                                    item.name
                                }}</label>
                            </div>
                        </div>
                    </b-collapse>

                </div>

            </div>
            <div class="col-md-8">
                <div class="row">
                    <div class="col-md-8">

                    </div>
                    <div class="col-md-4">
                        <a style="margin-top: 10px; width: max-content; float: right;" v-if="isShowFile"
                            href="javascript:;"
                            class="item btn btn-main border-rd-20 font-size-16 display-flex-center item__add"
                            @click="handleDownLoadFile">

                            Tải xuống
                        </a>
                    </div>
                </div>
                <ViewQuestion :listQuestion="listQuestion" :learningTaskId="learningTaskId" v-if="isShowQuestion" />
                <div v-if="!isShowQuestion" class="view-item"
                    :class="{ 'view-document': itemDocumentSelected.typeDocument != 3 }">

                    <ViewDocument :isEnableWork="true" @handleDoWorDone="handleDoWorDone" v-if="isShowDocument"
                        :item="itemDocumentSelected" />
                    <ViewFile :path="pathSelected" v-if="isShowFile" />
                </div>
            </div>
        </div>

    </div>
</template>
<script>

import { GetListLessonPlaning } from './../../_api/LessonClassSchoolServices'
import { PLANING_LESSON_WAREHOUSE, PLANING_LESSON_ASSIGN, ELECTRONIC_LECTURE_WAREHOUSE, ELECTRONIC_LECTURE_ASSIGN } from './../../constants/constants_enum'
import ViewDocument from './../../_components/ViewDocument'
import { getListLearningTaskLesson, getListQuestion } from './../../_api/learningTask'
import { listFileClassSchool, listFileElectronicByLessonPlaning, downloadFile } from './../../_api/fileClassSchoolServices'
import { saveDocumentUserClassSchool } from './../../_api/documentUserClassSchoolServices'
import ViewFile from './../../_components/ViewFile'
import ViewQuestion from './../../_components/ViewQuestion'
export default {
    props: {
        dataLessonPlaning: {
            type: Object,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: {}
        }
    },
    components: {
        ViewDocument,
        ViewFile,
        ViewQuestion
    },
    data() {
        return {
            listLessonPlaning: [],
            PLANING_LESSON_WAREHOUSE, PLANING_LESSON_ASSIGN, ELECTRONIC_LECTURE_WAREHOUSE, ELECTRONIC_LECTURE_ASSIGN,
            paramQueryData: {
                lessonClassSchoolId: 0,
                classSchoolId: 0,
                id: 0,
                type: PLANING_LESSON_WAREHOUSE,
                keyword: '',
                pageIndex: 1,
                pageSize: 5,
            },
            isShowDocument: false,
            isShowFile: false,
            isShowQuestion: false,
            classSchoolId: 0,
            itemDocumentSelected: {},
            paramQueryDataFile: {
                lessonClassSchoolId: 0,
            },
            listDataFile: [],
            totalRecordsFile: 0,
            listLearningTaskLesson: [],
            learningTaskId: 0,
            listQuestion: [],
            isClickDocument: false,
            isCollapseLearningTask: false,
            isCollapseFile: false,
            pathSelected: '',
            nameSelected: '',
        }
    },
    mounted() {
        this.paramQueryData.id = this.paramQueryDataFile.lessonClassSchoolId = this.paramQueryData.lessonClassSchoolId = this.$route.query.id
        this.classSchoolId = this.paramQueryData.classSchoolId = this.$route.query.classSchoolId
        this.getListLessonPlaning()
        this.getDataFile()
        this.getListLearningTask()
        //this.getListQuestionByLearningTask()
    },
    methods: {
        handleOnCollapseFile() {
            this.isCollapseFile = !this.isCollapseFile
        },
        handleCollapseLearningTask() {
            this.isCollapseLearningTask = !this.isCollapseLearningTask
        },
        handleDownLoadFile() {
            let data = {
                path: this.pathSelected,
                fileName: this.nameSelected
            }
            downloadFile(data)
        },
        handleOnCollapse(item) {
            item.isCollapse = !item.isCollapse
            console.log('ádasd')
        },
        handleOnViewFile(file) {
            this.viewFile()
            this.pathSelected = file.path
            this.nameSelected = file.fileName
        },
        handleOnTask(item) {
            this.isShowQuestion = false
            this.isShowDocument = false,
                this.isClickTask = true
            this.learningTaskId = item.learningTaskId
            this.getListQuestionByLearningTask()
        },
        viewQuestion() {
            this.isShowQuestion = true
            this.isShowDocument = false,
                this.isShowFile = false
        },
        viewFile() {
            this.isShowQuestion = false
            this.isShowDocument = false,
                this.isShowFile = true
        },
        viewDocument() {
            this.isShowQuestion = false
            this.isShowDocument = true,
                this.isShowFile = false
        },
        handleOnViewDocument(isCheck, document) {
            let self = this

            if (document.typeDocument != 3) {
                document.isCheck = true
            }
            this.viewDocument()
            this.itemDocumentSelected = document

            let params = {
                lesssonPlaningId: this.paramQueryData.id,
                classSchoolId: this.classSchoolId,
                lessonClassSchoolId: document.lessonClassSchoolId,
                ChapId: document.chapterId,
                postId: document.postId,
                documentId: document.id,
                type: PLANING_LESSON_WAREHOUSE,
                status: 2
            }
            if (document.typeDocument != 3) {
                saveDocumentUserClassSchool(params).then(() => {
                    // eslint-disable-next-line no-empty

                })
            }
        },
        handleDoWorDone(document) {
            let params = {
                lesssonPlaningId: this.paramQueryData.id,
                classSchoolId: this.classSchoolId,
                lessonClassSchoolId: document.lessonClassSchoolId,
                ChapId: document.chapterId,
                postId: document.postId,
                documentId: document.id,
                type: PLANING_LESSON_WAREHOUSE,
                status: 2
            }
            saveDocumentUserClassSchool(params).then(() => {
                // eslint-disable-next-line no-empty

            })
        },
        formatSizeFile(data, to = 'MB') {
            const const_term = 1024;

            // Convert the values and concatenate 
            // the appropriate unit 
            if (to === "KB") {
                return (data / const_term).toFixed(3) + "KB";
            } else if (to === "MB") {
                return (data / const_term ** 2).toFixed(3) + "MB";
            } else if (to === "GB") {
                return (data / const_term ** 3).toFixed(3) + "GB";
            } else if (to === "TB") {
                return (data / const_term ** 4).toFixed(3) + "TB";
            } else {
                return "";
            }
        },
        getDataFile() {
            let self = this
            listFileElectronicByLessonPlaning(this.paramQueryDataFile).then(res => {
                if (res && res.data && !res.errors) {
                    self.listDataFile = res.data
                    //self.totalRecordsFile = res.data.paging.totalRecords
                }
            })
        },
        getListLessonPlaning() {
            let self = this
            GetListLessonPlaning(this.paramQueryData).then(res => {
                if (res && res.data && !res.errors) {
                    self.listLessonPlaning = res.data
                }
            })
        },
        getListLearningTask() {
            let self = this
            getListLearningTaskLesson(self.paramQueryData).then(res => {
                if (res && res.data && !res.errors) {
                    self.listLearningTaskLesson = res.data.list
                    self.totalRecords = res.data.paging.totalRecords

                }
            })

        },

        getListQuestionByLearningTask() {
            let self = this
            let params = {
                lessonClassSchoolId: this.paramQueryData.id,
                classSchoolId: this.classSchoolId,
                learningTaskId: self.learningTaskId
            }
            getListQuestion(params).then(res => {
                if (res && res.data && !res.errors) {
                    self.listQuestion = res.data
                }
                this.viewQuestion()
            })

        },
    }
}
</script>
<style>

</style>
<style lang="scss" scoped>
.margin-top-10 {
    margin-top: 10px;
}

.item-document {
    color: blue;
    cursor: pointer;
}

.wrap-list-file .file-name {
    cursor: pointer;
}

.width-20 {
    width: 20px;
}

.view-document {
    margin-top: 20px;
    height: 44rem;
    overflow: auto;
    background: rgb(241, 240, 240);
    border-radius: 10px;
    margin-bottom: 10px;
    border: 1px solid gray;
    padding: 5px;
}

.view-item {
    height: 44rem;

}

.item-file {
    cursor: pointer;
}

.wrap-left {
    max-height: 40rem;
    overflow: auto;

    .item-electronic-lecture {
        .name {
            padding-bottom: 0px;
            border-bottom: 1px solid #d3dbe0;
        }

        .wrap-list-chapter {
            margin-top: 3px;

            .item-chapter {
                padding-bottom: 0px;
                //border-bottom: 1px solid #d3dbe0;
            }

            .wrap-list-post {
                margin-top: 3px;
            }
        }
    }
}

.icon-photo {
    width: 20px;
    top: 0px !important;
    display: inline-block;
}

.indented {
    margin-left: 20px;
    /* Đặt giá trị thụt cách tùy ý */
}

.wrap-list-task-lesson .tittle {
    border-bottom: 1px solid #d3dbe0;
    margin-bottom: 10px;
}

.display-flex {
    display: flex;
}

.rg-half-1 {
    row-gap: 0.5rem;
}

.cursor-pointer {
    cursor: pointer;
}
</style>